import { render, staticRenderFns } from "./QuotationForm.vue?vue&type=template&id=4dafe998&scoped=true"
import script from "./QuotationForm.vue?vue&type=script&lang=js"
export * from "./QuotationForm.vue?vue&type=script&lang=js"
import style0 from "./QuotationForm.vue?vue&type=style&index=0&id=4dafe998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dafe998",
  null
  
)

export default component.exports